<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let variant: 'primary' | 'secondary' | 'danger' | 'success' = 'primary';
  export let disabled: boolean = false;
  export let size: 'xs' | 'sm' | 'md' | 'lg' = 'md';
  export let fullWidth: boolean = false;
  export let type: 'button' | 'submit' | 'reset' = 'button';
  export let className: string = '';
  export let title: string = '';
  export let extraClass: string = '';

  const dispatch = createEventDispatcher();

  function handleClick(event: MouseEvent) {
    if (!disabled) {
      dispatch('click', event);
    }
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !disabled) {
      dispatch('click', event as any);
    }
  }

  $: buttonClasses = [
    'cursor-pointer',
    'btn',
    `btn-${variant}`,
    disabled ? 'btn-disabled' : '',
    fullWidth ? 'w-full' : '',
    size === 'xs' ? 'px-1 py-0.5 text-xs' : '',
    size === 'sm' ? 'px-2 py-1 text-xs' : '',
    size === 'lg' ? 'px-4 py-3 text-base' : '',
    className,
    extraClass,
  ]
    .filter(Boolean)
    .join(' ');
</script>

<button
  {type}
  class={buttonClasses}
  {disabled}
  {title}
  on:click={handleClick}
  on:keydown={handleKeydown}
>
  <slot />
</button>

<style lang="postcss">
  @reference "@/styles/theme.css";
</style>
